import { render, staticRenderFns } from "./SecurityValidation.vue?vue&type=template&id=2e1a6444"
import script from "./SecurityValidation.vue?vue&type=script&lang=js"
export * from "./SecurityValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports